<ng-template #template><ng-content /></ng-template>
